/**
 * ============================================================================
 * STATUS BADGE COMPONENT
 * ============================================================================
 * 
 * Reusable status badge component with consistent styling
 */

import React from 'react';

/**
 * Status Badge Component
 * @param {Object} props
 * @param {string} props.status - Status value
 * @param {string} props.variant - Badge variant (default, success, warning, error, info)
 * @param {string} props.size - Badge size (sm, md, lg)
 * @param {string} props.className - Additional classes
 * @returns {JSX.Element}
 */
const StatusBadge = ({ 
  status, 
  variant = 'default', 
  size = 'md',
  className = '',
  children 
}) => {
  /* LinkedIn/Cursor: pill (border-radius 12px), 12-13px text, padding 4px 12px */
  const variants = {
    default: 'bg-[#F3F4F6] text-[#374151]',
    success: 'bg-[#D1FAE5] text-[#059669]',
    warning: 'bg-[#FEF3C7] text-[#D97706]',
    error: 'bg-[#FEE2E2] text-[#DC2626]',
    info: 'bg-[#DBEAFE] text-[#1D4ED8]',
  };

  const sizes = {
    sm: 'px-3 py-1 text-xs',
    md: 'px-3 py-1 text-[13px]',
    lg: 'px-3 py-1.5 text-sm',
  };

  const classes = `
    inline-flex items-center justify-center
    rounded-full font-medium
    ${variants[variant] || variants.default}
    ${sizes[size] || sizes.md}
    ${className}
  `.trim().replace(/\s+/g, ' ');

  return (
    <span className={classes}>
      {children || status}
    </span>
  );
};

export default StatusBadge;
